import { render, staticRenderFns } from "./issueContents.vue?vue&type=template&id=73c5bdd0&"
import script from "./issueContents.vue?vue&type=script&lang=ts&"
export * from "./issueContents.vue?vue&type=script&lang=ts&"
import style0 from "./issueContents.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports